export default __webpack_public_path__ + "static/media/event.edb2b056.png";